import { SetStateAction, useContext, useEffect, useState } from "react";
import { Checkbox, FormControlLabel, FormGroup, MenuItem, Paper, Select, Snackbar, TableContainer, Toolbar, Typography } from "@mui/material";
import React from "react";
import { CustomTextField, CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { useLocation } from "react-router-dom";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { ICabecalho } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { IZonaHomogenea } from "../../../Interfaces/cadernos/zona_homogenea";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { Alert } from "../../../Components/Alert/Alert";
import LoadingVulpesSmall from "../../../Styles/Loader/loadingSmall";
import { AuthContext } from "../../../AuthContext/AuthContext";
import BasicPopover from "../../../Components/Popover";
import { grey } from "@mui/material/colors";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";

interface CabecalhoA1Form_prop {
  set_obj_anexo_cabecalho_selecionado: React.Dispatch<SetStateAction<ICabecalho | undefined>>;
  obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
}

export const CabecalhoA1Form: React.FC<CabecalhoA1Form_prop> = ({
  obj_anexo_cabecalho_selecionado
  , set_obj_anexo_cabecalho_selecionado }) => {
  const auth = useContext(AuthContext);

  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [especie_ou_lote_homegenio_selecionada, set_especie_ou_lote_homegenio_selecionada] = useState<IZonaHomogenea>();
  const [especie_ou_lote_homegenio_lista, set_especie_ou_lote_homegenio_lista] = useState<IZonaHomogenea[]>([]);
  const [cultura_selecionada, set_cultura_selecionada] = useState<any>();

  const [obj_anexo_cabecalho, set_obj_anexo_cabecalho] = useState<ICabecalho>();
  const [obj_anexo_cabecalho_lista, set_obj_anexo_cabecalho_lista] = useState<ICabecalho[]>();
  const [obj_anexo_cabecalho_to_edit, set_obj_anexo_cabecalho_to_edit] = useState<ICabecalho>();
  const [obj_anexo_cabecalho_backup, set_obj_anexo_cabecalho_backup] = useState<ICabecalho | undefined>(undefined);

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);

  const [flag_editar_cabecalho, set_flag_editar_cabecalho] = useState(false)

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [error_idade, set_error_idade] = React.useState(false);
  const [error_producao_esperado, set_error_producao_esperado] = React.useState(false);

  const [parcela_selecionada, set_parcela_selecionada] = useState<IZonaHomogenea>();
  const [parcelas_lista, set_parcelas_lista] = useState<IZonaHomogenea[]>([]);


  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);
  const [isEditingCultura, setIsEditingCultura] = useState(false);


  const onInputEditTableChange_cabecalho = (event: any) => {
    const { name, value, type, checked } = event.target;
    set_flag_editado(true)
    if (type === "checkbox") {
      if (checked) {
        set_obj_anexo_cabecalho_to_edit((old: any) => ({
          ...old,
          insta: false,
          manutencao: false,
          producao: false,
          [name]: checked,
        }));
      } else {
        set_obj_anexo_cabecalho_to_edit((old: any) => ({
          ...old,
          [name]: checked,
        }));
      }
    } else {
      if (name === 'idade') {
        if (!/^\d+$/.test(value)) {
          set_error_idade(true)
        } else {
          set_error_idade(false)
        }
        set_obj_anexo_cabecalho_to_edit((old: any) => ({
          ...old,
          [name]: value,
        }));
      } else if (name === 'producao_esperado') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_producao_esperado(true)
        } else {
          set_error_producao_esperado(false)
        }

        set_obj_anexo_cabecalho_to_edit((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else {
        set_obj_anexo_cabecalho_to_edit((old: any) => ({
          ...old,
          [name]: value,
        }));
      }

    }
  };

  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };

  const atualizarListaZonasComCabecalhos = (
    listaZonas: any[],
    listaCabecalhos: ICabecalho[]
  ) => {
    const resultado = listaZonas.map((zona) => ({
      ...zona,
      culturas: [...(zona.culturas ?? [])],
    }));

    listaCabecalhos.forEach((item: ICabecalho) => {
      const zona = resultado.find(
        (z) => z.zona_homogenea === item.zona_homo
      );

      const novaCultura = {
        cultura: item.cultura,
        area: item.area,
      };

      if (!zona) {
        resultado.push({
          zona_homogenea: item.zona_homo,
          culturas: [novaCultura],
        });
      } else {
        const culturaExiste = zona.culturas.some(
          (c: any) => c.cultura === item.cultura
        );

        if (!culturaExiste) {
          zona.culturas.push(novaCultura);
        }
      }
    });

    return resultado;
  };
  const get_info = async () => {
    try {

      let res = await get(auth.token.cookie_token,
        `/zona_homgenea_caraterizacao/${location.state.id_rosto}`
        // `/get_reg_anexo_um__cabecalho_rosto/${location.state.id_rosto}`
      );
      let res_cabecalho = await get(auth.token.cookie_token,
        `/get_reg_anexo_um__cabecalho_rosto/${location.state.id_rosto}`
        // `/get_reg_anexo_um_um_cabecalho/${location.state.id_rosto}`
      );

      let res_parcelas = await get(auth.token.cookie_token,
        `/parcela_caraterizacao_lista/${location.state.id_rosto}`
        // `/get_reg_anexo_um_um_cabecalho/${location.state.id_rosto}`
      );
      if (res.status === 200 && res_cabecalho.status === 200 && res_parcelas.status === 200) {
        // set_flag_editar_cabecalho(false)
        if (res.data.result.length !== 0) {
          const resultado = atualizarListaZonasComCabecalhos(
            res.data.result,
            res_cabecalho.data.result
          );
          set_especie_ou_lote_homegenio_lista(resultado);
          set_especie_ou_lote_homegenio_selecionada(resultado[0])
          set_cultura_selecionada(resultado[0].culturas[0])

          if (res_cabecalho.data.result.length !== 0) {
            set_obj_anexo_cabecalho_lista(res_cabecalho.data.result)

            let obj_aux = res_cabecalho.data.result?.find((el: ICabecalho) => el.zona_homo === resultado[0].zona_homogenea)

            if (obj_aux === undefined) {

              set_flag_editar_cabecalho(true)

            } else {
              set_obj_anexo_cabecalho_to_edit(obj_aux)
              set_obj_anexo_cabecalho(obj_aux)
              set_obj_anexo_cabecalho_selecionado(obj_aux)
              set_obj_anexo_cabecalho_backup(obj_aux)
              set_cultura_selecionada(resultado[0].culturas.find((el: any) => el.cultura === obj_aux.cultura))

            }

          } else {
            set_flag_editar_cabecalho(true)

          }
        }

        if (res_parcelas.data.result.length !== 0) {
          set_parcelas_lista(res_parcelas.data.result.sort(
            (a: any, b: any) => a.n_sequencia - b.n_sequencia
          ));
          set_parcela_selecionada(undefined)
        }


      } else {
        setMessage("Erro a carregar informação!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    } catch (error) {
      func_print("get_info", error, true);
      setMessage("Erro!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  };
  const handle_change_cultura = (cultura_selecionad: string) => {

    let aux_cultura_selecionada = especie_ou_lote_homegenio_selecionada?.culturas.find((el: any) => el.cultura === cultura_selecionad)

    set_cultura_selecionada(aux_cultura_selecionada)

    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho) => el.zona_homo === especie_ou_lote_homegenio_selecionada?.zona_homogenea && aux_cultura_selecionada.cultura === el.cultura)

    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)

    } else {
      set_flag_editar_cabecalho(false)


    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)

  }
  const handle_change_zona_homogenea = (zona_homogenea_selecionada: string) => {
    set_obj_anexo_cabecalho_selecionado(undefined)
    set_parcela_selecionada(undefined)

    let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista.find((el: IZonaHomogenea) => el.zona_homogenea === zona_homogenea_selecionada)

    set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)

    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho) => el.zona_homo === zona_homogenea_selecionada)
    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
      set_cultura_selecionada(aux_obj_zona_homogenea_selecionada?.culturas[0])

    } else {
      set_flag_editar_cabecalho(false)
      set_cultura_selecionada(aux_obj_zona_homogenea_selecionada?.culturas.find((el) => el.cultura === obj_aux?.cultura))

    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)


  }
  const handle_change_parcela = (parcela_selecionada: string) => {
    set_obj_anexo_cabecalho_selecionado(undefined)
    set_parcela_selecionada(undefined)
    set_especie_ou_lote_homegenio_selecionada(undefined)
    const [n_sequencia, sub_parcela] = parcela_selecionada.split(' - ');

    let aux_obj_parcela_selecionada = parcelas_lista.find((el: IZonaHomogenea) => el.n_sequencia.toString() === n_sequencia.toString() && el.sub_parcela.toString() === sub_parcela.toString())

    set_parcela_selecionada(aux_obj_parcela_selecionada)
    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho) => el.n_sequencia !== null && el.n_sequencia.toString() === n_sequencia.toString() && el.n_subparcela.toString() === sub_parcela.toString())
    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
    } else {
      set_flag_editar_cabecalho(false)
    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)
  }

  const handle_criar_cabecalho = async () => {
    if (error_idade || error_producao_esperado) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {

      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "new_reg_anexo_um_cabecalho", {
          payload: {
            id_anexo_um_cabecalho: 0,
            zona_homo: parcela_selecionada !== undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea,
            n_sequencia: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.n_sequencia === undefined ? null : parcela_selecionada?.n_sequencia.toString()
              : especie_ou_lote_homegenio_selecionada?.n_sequencia === undefined ? null : especie_ou_lote_homegenio_selecionada?.n_sequencia.toString(),
            n_subparcela: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.sub_parcela === undefined ? null : parcela_selecionada?.sub_parcela.toString()
              : especie_ou_lote_homegenio_selecionada?.sub_parcela === undefined ? null : especie_ou_lote_homegenio_selecionada?.sub_parcela.toString(),
            area: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.area === undefined ? null : parcela_selecionada?.area
              : cultura_selecionada?.area === undefined ? null : cultura_selecionada?.area,
            cultura: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.cultura === undefined ? null : parcela_selecionada?.cultura
              : cultura_selecionada?.cultura === undefined ? null : cultura_selecionada?.cultura,
            idade: obj_anexo_cabecalho_to_edit?.idade === undefined ? null : obj_anexo_cabecalho_to_edit?.idade,
            producao_esperado: obj_anexo_cabecalho_to_edit?.producao_esperado === undefined ? null : obj_anexo_cabecalho_to_edit?.producao_esperado,
            insta: obj_anexo_cabecalho_to_edit?.insta === undefined ? null : obj_anexo_cabecalho_to_edit?.insta,
            manutencao: obj_anexo_cabecalho_to_edit?.manutencao === undefined ? null : obj_anexo_cabecalho_to_edit?.manutencao,
            producao: obj_anexo_cabecalho_to_edit?.producao === undefined ? null : obj_anexo_cabecalho_to_edit?.producao,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })
        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_flag_editado(false)

          set_obj_anexo_cabecalho(data.data.result)
          if (obj_anexo_cabecalho_lista?.length === 0 || obj_anexo_cabecalho_lista === undefined) {
            set_obj_anexo_cabecalho_lista([data.data.result])

          } else {
            set_obj_anexo_cabecalho_lista((old: any) => [...old, data.data.result])

          }
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          set_obj_anexo_cabecalho_selecionado(data.data.result)
          set_obj_anexo_cabecalho_backup(data.data.result)

          set_flag_editar_cabecalho(false)

        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);

      } catch (error) {
        func_print('handle_criar_cabecalho', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }

  }

  const handle_editar_cabecalho = async () => {
    if (error_idade || error_producao_esperado) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {
      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "update_reg_anexo_um__cabecalho", {
          payload: {
            id_anexo_um_cabecalho: obj_anexo_cabecalho_to_edit?.id_anexo_um_cabecalho === undefined ? null : obj_anexo_cabecalho_to_edit?.id_anexo_um_cabecalho,
            zona_homo: parcela_selecionada !== undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea,
            n_sequencia: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.n_sequencia === undefined ? null : parcela_selecionada?.n_sequencia.toString()
              : especie_ou_lote_homegenio_selecionada?.n_sequencia === undefined ? null : especie_ou_lote_homegenio_selecionada?.n_sequencia.toString(),
            n_subparcela: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.sub_parcela === undefined ? null : parcela_selecionada?.sub_parcela.toString()
              : especie_ou_lote_homegenio_selecionada?.sub_parcela === undefined ? null : especie_ou_lote_homegenio_selecionada?.sub_parcela.toString(),
            area: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.area === undefined ? null : parcela_selecionada?.area
              : cultura_selecionada?.area === undefined ? null : cultura_selecionada?.area,
            cultura: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.cultura === undefined ? null : parcela_selecionada?.cultura
              : cultura_selecionada?.cultura === undefined ? null : cultura_selecionada?.cultura,
            idade: obj_anexo_cabecalho_to_edit?.idade === undefined ? null : obj_anexo_cabecalho_to_edit?.idade,
            producao_esperado: obj_anexo_cabecalho_to_edit?.producao_esperado === undefined ? null : obj_anexo_cabecalho_to_edit?.producao_esperado,
            insta: obj_anexo_cabecalho_to_edit?.insta === undefined ? null : obj_anexo_cabecalho_to_edit?.insta,
            manutencao: obj_anexo_cabecalho_to_edit?.manutencao === undefined ? null : obj_anexo_cabecalho_to_edit?.manutencao,
            producao: obj_anexo_cabecalho_to_edit?.producao === undefined ? null : obj_anexo_cabecalho_to_edit?.producao,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })


        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_flag_editado(false)

          set_flag_editar_cabecalho(false)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          set_obj_anexo_cabecalho(data.data.result)
          set_obj_anexo_cabecalho_selecionado(data.data.result)
          set_obj_anexo_cabecalho_backup(data.data.result)
          set_flag_editar_cabecalho(false)
          let aux = obj_anexo_cabecalho_lista?.map((el) => {
            if (el.id_anexo_um_cabecalho === data.data.result.id_anexo_um_cabecalho) {
              return data.data.result
            } else {
              return el
            }
          })
          set_obj_anexo_cabecalho_lista(aux)
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print('handle_editar_cabecalho', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }

  }

  const handle_delete_cabecalho = async () => {
    try {

      setIsLoading(true);
      let data = await del(auth.token.cookie_token, `delete_anexo_um__cabecalho/${obj_anexo_cabecalho?.id_anexo_um_cabecalho}`)
      if (data.status === 200) {
        let lista_aux: any = obj_anexo_cabecalho_lista?.filter((el) => {
          if (el.id_anexo_um_cabecalho !== obj_anexo_cabecalho?.id_anexo_um_cabecalho) {
            return el
          }
        })
        setMessage("Eliminado com sucesso!");
        set_open_dialog_tem_a_certeza_que_quer_eliminar(false)
        setOpenSnackSuccess(true);
        set_obj_anexo_cabecalho_lista(lista_aux === undefined ? [] : lista_aux)
        set_obj_anexo_cabecalho_selecionado(undefined)
        set_obj_anexo_cabecalho(undefined)
        set_obj_anexo_cabecalho_to_edit(undefined)
        set_flag_editar_cabecalho(true)
        set_obj_anexo_cabecalho_backup(undefined)
      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {

      func_print('handle_delete_cabecalho', error, true)
      setIsLoading(false);

      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
    }
  }
  const handleCloseDialog = () => {
    set_error_idade(false)
    set_error_producao_esperado(false)

    if (obj_anexo_cabecalho_backup) {
      set_obj_anexo_cabecalho_to_edit(obj_anexo_cabecalho_backup);
    } else {
      set_obj_anexo_cabecalho_to_edit(undefined)
    }

    set_flag_editar_cabecalho(false)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);

  return (
    <form>
      <CustomThemeProvider>
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {isLoading ?
            <LoadingVulpesSmall />
            :
            <Toolbar
              style={{
                paddingTop: 3,
                paddingBottom: 10,
                fontFamily: "candara",
                display: "flex",
                flexDirection: 'column',
              }}
            >
              <div style={{
                width: '100%',

              }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: 'row',
                  }}
                >
                  <h1
                    style={{
                      fontWeight: 600,
                      fontSize: 20,
                      fontFamily: "candara",
                    }}
                  >
                    Anexo 1 - Plano de Fertilização
                  </h1>
                  <BasicPopover
                    text={
                      "O Plano de Fertilização é obrigatório para as seguintes intervenções PEPAC: Agricultura Biológica, Produção Integrada, Maneio da Pastagem Permanente, Promoção da Fertilização Orgânica, Conservação do Solo - Pastagens Biodiversas e Uso Eficiente da Água. \nPretende-se que o Agricultor/operador apresente uma estimativa das fertilizações a efetuar, com base nos resultados dos boletins de análise, nas produções esperadas, tendo em consideração as recomendações do Manual de Fertilização das Culturas do INIAV (2022), as recomendações constantes do normativo de Produção Integrada ou o Regulamento n.º 2018/848 (produção biológica). \n\Deve ser elaborado um plano por zona homogénea, se a diferença entre zonas homogéneas o justificar. O Plano de Fertilização é obrigatório, mas pode ser apresentado segundo outro modelo, desde que contenha a informação solicitada neste quadro. \n\nO Plano de Fertilização, no caso de o beneficiário assim o desejar, pode ser utilizado para cumprimento das suas obrigações no âmbito da Condicionalidade - indicador 3.2 do RLG 2 da Portaria n.º 54-Q/2023 (quadros 1.1, 1.2 e 1.3 apenas para o azoto) e do Programa de Ação das Zonas Vulneráveis. \n\nNo caso de parcelas localizadas em Zona Vulnerável, o plano de fertilização deve cumprir as disposições constantes da portaria n.º 259/2012, de 28 de agosto. No âmbito da Portaria n.º 259/2012 não são de preenchimento obrigatório os campos referentes à fase da cultura permanente e os quadros 1.4 e 1.5. No entanto, o quadro 1.4 pode ser utilizado para apoio dos cálculos referentes aos fertilizantes orgânicos. Nos quadro 1.1, 1.2, 1.3, 1.7, 2, 3 e 4 apenas é obrigatório o preenchimento referente ao azoto (N) e dos campos complementares de cada um dos referidos quadros."
                    }
                  />
                </div>
                <hr
                  style={{
                    width: '100%',
                    height: 1,
                    backgroundColor: grey[300],
                    border: 'none',
                  }}
                />
                <div style={{
                  width: '100%',
                  display: "flex",
                  flexDirection: 'row',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',

                }}>
                  {
                    parcelas_lista.length === 0 || especie_ou_lote_homegenio_lista.length === 0 ? <></> :

                      obj_anexo_cabecalho === undefined ?
                        is_historico === true ? <></> :

                          <ButtonCadernos

                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_criar_cabecalho() }}
                          />
                        :
                        flag_editar_cabecalho === true ?
                          <ButtonCadernos
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {

                                set_flag_editar_cabecalho(false)
                                if (obj_anexo_cabecalho_backup) {
                                  set_obj_anexo_cabecalho_to_edit(obj_anexo_cabecalho_backup);
                                }
                              }

                            }
                            }
                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_editar_cabecalho() }}
                          /> :
                          is_historico === true ? <></> :

                            <ButtonCadernos
                              mostrarBotaoApagar
                              mostrarBotaoEditar
                              aoClicarApagar={() => { set_open_dialog_tem_a_certeza_que_quer_eliminar(true) }}
                              aoClicarEditar={() => {
                                set_flag_editar_cabecalho(true)
                                set_obj_anexo_cabecalho_backup(obj_anexo_cabecalho_to_edit)
                              }}
                            />


                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    Zona Homogénea
                    <Select
                      value={especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? '' : especie_ou_lote_homegenio_selecionada?.zona_homogenea}
                      label={''}
                      name={'zona_homogenea'}
                      sx={{
                        fontSize: 14,
                        fontFamily: "verdana",
                        minWidth: 200,
                      }}
                      onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                    >

                      {especie_ou_lote_homegenio_lista
                        ?.filter((item: any) => item?.zona_homogenea)
                        .sort((a, b) =>
                          (a.zona_homogenea ?? '').localeCompare(b.zona_homogenea ?? '', 'pt', {

                            sensitivity: 'base',
                          })
                        ).map((item: IZonaHomogenea, key) => {

                          return (
                            <MenuItem key={key} value={item.zona_homogenea}>
                              <Typography
                                style={{
                                  fontSize: 14,
                                  fontFamily: "candara",
                                }}
                              >
                                {item.zona_homogenea}
                              </Typography>
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.1,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    Ou

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.15,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    <BasicPopover
                      text={
                        " N.º sequencial da parcela - Preencher com o n.º sequencial da parcela constante do iE do agricultor e anexar o respetivo iE.  \nParcela é a área delimitada geograficamente com uma identificação única conforme registado no Sistema de Identificação Parcelar (iSIP). \nO iE é o documento de caraterização da exploração agrícola resultante da identificação das parcelas da exploração no iSIP; esta caraterização da exploração encontra-se no documento IFAP e nele consta o n.º sequencial da parcela ou baldio; n.º do parcelário; nome da parcela; área da parcela; IQFP, entre outros. "
                      }
                    />
                    Nº Seq. Parcela:  <Select
                      value={parcela_selecionada?.n_sequencia === undefined && parcela_selecionada?.sub_parcela === undefined ? '' : parcela_selecionada?.n_sequencia + ' - ' + parcela_selecionada?.sub_parcela}
                      label={''}
                      name={'n_sequencia'}
                      sx={{
                        fontSize: 14,
                        fontFamily: "verdana",
                        minWidth: 200,
                      }}
                      onChange={(e) => handle_change_parcela(e.target.value)}
                    >

                      {parcelas_lista.map((item: IZonaHomogenea, key) => {

                        return (
                          <MenuItem key={key} value={item.n_sequencia + ' - ' + item.sub_parcela}>

                            <Typography
                              style={{
                                fontSize: 14,
                                fontFamily: "candara",
                              }}
                            >
                              {item.n_sequencia + ' -> nº subparcela: ' + item.sub_parcela}
                            </Typography>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    <BasicPopover
                      text={
                        " Preencher com o n.º de subparcela constante no iE para a corresponde parcela com o n.º sequencial registado no campo anterior. \nEntende-se por Subparcela a área corresponde à porção contínua de terreno homogéneo com a mesma ocupação de solo existente numa mesma parcela e que consta do documento iE"
                      }
                    />
                    Nº Subparcela: {parcela_selecionada?.sub_parcela}
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    Área (ha): {especie_ou_lote_homegenio_selecionada === undefined ? parcela_selecionada?.area.toFixed(2) : cultura_selecionada?.area.toFixed(2)}
                  </div>
                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    gap: 8,
                    border: '1px solid silver',
                    padding: 8,
                    borderRadius: 5,
                  }}>
                    Cultura e variedade:
                    {


                      // se o cabeçalho tiver criado -> obj_anexo_cabecalho
                      obj_anexo_cabecalho !== undefined ?
                        // se eu estiver a editar o cabeçalho -> obj_anexo_cabecalho_to_edit
                        flag_editar_cabecalho === true ?
                          // se eu escolher nao editar a cultura do cabeçalho que existe -> obj_anexo_cabecalho_to_edit
                          // !isEditingCultura ?
                          //   obj_anexo_cabecalho_to_edit?.cultura === undefined ? '' : obj_anexo_cabecalho_to_edit?.cultura
                          //   :
                          // se eu escolher editar a cultura do cabeçalho que ja existe -> obj_anexo_cabecalho_to_edit + parcela_selecionada +especie_ou_lote_homegenio_selecionada
                          especie_ou_lote_homegenio_selecionada !== undefined ? // se eu tiver selecionado uma zona homogenea -> especie_ou_lote_homegenio_selecionada
                            !isEditingCultura ?
                              <Select
                                value={cultura_selecionada?.cultura ?? ''}
                                name={'cultura'}
                                sx={{
                                  fontSize: 14,
                                  fontFamily: "verdana",
                                  minWidth: 200,
                                }}
                                onChange={(e) => {
                                  handle_change_cultura(e.target.value)
                                }}
                              >
                                {especie_ou_lote_homegenio_selecionada?.culturas
                                  .sort((a, b) =>
                                    (a?.cultura ?? '').localeCompare(b?.cultura ?? '', 'pt', {
                                      sensitivity: 'base',
                                    })
                                  )
                                  .map((item: any, key) => (
                                    <MenuItem key={key} value={item.cultura}>
                                      <Typography sx={{ fontSize: 14, fontFamily: "candara" }}>
                                        {item.cultura}
                                      </Typography>
                                    </MenuItem>
                                  ))}
                              </Select>
                              :
                              <CustomTextField
                                name="cultura"
                                minWidth={200}
                                value={cultura_selecionada?.cultura === undefined ? '' : cultura_selecionada?.cultura}
                                onChange={(e: any) => {

                                  set_especie_ou_lote_homegenio_selecionada((old: any) => ({
                                    ...old,
                                    culturas: old.culturas.map((el: any) => {
                                      if (el.cultura === cultura_selecionada?.cultura) {
                                        return {
                                          ...el,
                                          cultura: e.target.value,
                                        }
                                      } else {
                                        return el
                                      }
                                    })
                                  }))
                                  set_cultura_selecionada((old: any) => ({
                                    ...old,
                                    cultura: e.target.value,
                                  }))
                                }}
                              />
                            : // se eu  tiver selecionado uma parcela -> parcela_selecionada
                            <CustomTextField
                              name="cultura"
                              minWidth={800}
                              value={obj_anexo_cabecalho_to_edit?.cultura === undefined ? '' : obj_anexo_cabecalho_to_edit?.cultura}
                              onChange={(e: any) => {
                                set_parcela_selecionada((old: any) => ({
                                  ...old,
                                  cultura: e.target.value,
                                }))
                                set_obj_anexo_cabecalho_to_edit((old: any) => ({
                                  ...old,
                                  cultura: e.target.value,
                                }))
                              }}
                            />

                          :
                          // se eu nao estiver a editar o cabeçalho -> obj_anexo_cabecalho
                          especie_ou_lote_homegenio_selecionada !== undefined ?
                            <Select
                              value={cultura_selecionada?.cultura ?? ''}
                              name={'cultura'}
                              sx={{
                                fontSize: 14,
                                fontFamily: "verdana",
                                minWidth: 200,
                              }}
                              onChange={(e) => {
                                handle_change_cultura(e.target.value)
                              }}
                            >
                              {especie_ou_lote_homegenio_selecionada?.culturas
                                .sort((a, b) =>
                                  (a?.cultura ?? '').localeCompare(b?.cultura ?? '', 'pt', {
                                    sensitivity: 'base',
                                  })
                                )
                                .map((item: any, key) => (
                                  <MenuItem key={key} value={item.cultura}>
                                    <Typography sx={{ fontSize: 14, fontFamily: "candara" }}>
                                      {item.cultura}
                                    </Typography>
                                  </MenuItem>
                                ))}
                            </Select>
                            :
                            obj_anexo_cabecalho?.cultura === undefined ? '' : obj_anexo_cabecalho?.cultura
                        :
                        //  se o cabeçalho nao esta criado
                        especie_ou_lote_homegenio_selecionada !== undefined ? // se eu tiver selecionado uma zona homogenea -> especie_ou_lote_homegenio_selecionada
                          !isEditingCultura ?
                            <Select
                              value={cultura_selecionada?.cultura ?? ''}
                              name={'cultura'}
                              sx={{
                                fontSize: 14,
                                fontFamily: "verdana",
                                minWidth: 200,
                              }}
                              onChange={(e) => {
                                handle_change_cultura(e.target.value)
                              }}
                            >
                              {especie_ou_lote_homegenio_selecionada?.culturas
                                .sort((a, b) =>
                                  (a?.cultura ?? '').localeCompare(b?.cultura ?? '', 'pt', {
                                    sensitivity: 'base',
                                  })
                                )
                                .map((item: any, key) => (
                                  <MenuItem key={key} value={item.cultura}>
                                    <Typography sx={{ fontSize: 14, fontFamily: "candara" }}>
                                      {item.cultura}
                                    </Typography>
                                  </MenuItem>
                                ))}
                            </Select>
                            :
                            <CustomTextField
                              name="cultura"
                              minWidth={200}
                              value={cultura_selecionada?.cultura === undefined ? '' : cultura_selecionada?.cultura}
                              onChange={(e: any) => {

                                set_especie_ou_lote_homegenio_selecionada((old: any) => ({
                                  ...old,
                                  culturas: old.culturas.map((el: any) => {
                                    if (el.cultura === cultura_selecionada?.cultura) {
                                      return {
                                        ...el,
                                        cultura: e.target.value,
                                      }
                                    } else {
                                      return el
                                    }
                                  })
                                }))
                                set_cultura_selecionada((old: any) => ({
                                  ...old,
                                  cultura: e.target.value,
                                }))
                              }}
                            />
                          : // se eu  tiver selecionado uma parcela -> parcela_selecionada
                          !isEditingCultura ?
                            parcela_selecionada?.cultura === undefined ? '' : parcela_selecionada?.cultura
                            :
                            <CustomTextField
                              name="cultura"
                              minWidth={800}
                              value={parcela_selecionada?.cultura === undefined ? '' : parcela_selecionada?.cultura}
                              onChange={(e: any) => {
                                set_parcela_selecionada((old: any) => ({
                                  ...old,
                                  cultura: e.target.value,
                                }))
                              }}
                            />
                    }


                    <div style={{
                      display: "flex"
                      // , alignSelf: "flex-start",
                    }}>
                      {
                        flag_editar_cabecalho === false ? <></> :
                          isEditingCultura ?
                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={() => { setIsEditingCultura(prev => !prev) }}
                            />
                            :
                            <ButtonCadernos
                              mostrarBotaoEditar

                              aoClicarEditar={() => { setIsEditingCultura(prev => !prev) }}
                            />
                      }


                    </div>

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    <BasicPopover
                      text={"Preencher apenas para culturas ou pastagens permanentes"}
                    />
                    Idade (anos):
                    {
                      flag_editar_cabecalho === true ?

                        <CustomTextField
                          name="idade"
                          value={obj_anexo_cabecalho_to_edit?.idade === undefined ? '' : obj_anexo_cabecalho_to_edit?.idade}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_idade}
                          helperText={error_idade ? 'Apenas números são aceites' : ""}
                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.idade === null ? '' : obj_anexo_cabecalho?.idade}
                        </div>

                    }

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    Produção esperada (kg/ha):
                    {
                      flag_editar_cabecalho === true ?

                        <CustomTextField

                          name="producao_esperado"
                          value={obj_anexo_cabecalho_to_edit?.producao_esperado === undefined || obj_anexo_cabecalho_to_edit?.producao_esperado === null ? '' : obj_anexo_cabecalho_to_edit?.producao_esperado.toString().replace('.', ',')}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_producao_esperado}
                          helperText={error_producao_esperado ? 'Apenas números são aceites' : ""}
                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.producao_esperado === null || obj_anexo_cabecalho?.producao_esperado === undefined ? '' : obj_anexo_cabecalho?.producao_esperado.toString().replace('.', ',')}
                        </div>

                    }
                  </div>

                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    <BasicPopover
                      text={
                        "Assinalar com 'X' o campo da fase de desenvolvimento em que se encontra a cultura permanente a que corresponde o plano de fertilização."
                      }
                    />
                    Cultura permanente em fase de:

                  </div>

                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    <FormGroup

                      onChange={onInputEditTableChange_cabecalho} >
                      <FormControlLabel
                        name="insta"
                        /* disabled={false} */
                        label={
                          <Typography
                            fontFamily="candara"
                            fontSize={16}
                          >
                            Instalação
                          </Typography>
                        }
                        aria-readonly
                        value={obj_anexo_cabecalho_to_edit?.insta}
                        control={
                          /* 
                            checked={!!obj_anexo_cabecalho_to_edit?.c_1}
                            onChange={onInputEditTableChange_cabecalho}
                            name="c_1"
                            disabled={!flag_editar_cabecalho}
                          */
                          <Checkbox
                            checked={!!obj_anexo_cabecalho_to_edit?.insta}
                            onChange={onInputEditTableChange_cabecalho}
                            name="insta"
                            disabled={!flag_editar_cabecalho}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": {
                                color: "#C94F1E",
                              },
                            }}
                          />
                        }
                      />
                    </FormGroup>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    <FormGroup onChange={onInputEditTableChange_cabecalho}>
                      <FormControlLabel
                        name="manutencao"
                        /* disabled={false} */
                        label={
                          <Typography
                            fontFamily="candara"
                            fontSize={16}
                          >
                            Manutenção até entrada em produção
                          </Typography>
                        }
                        aria-readonly
                        value={obj_anexo_cabecalho_to_edit?.manutencao}

                        control={
                          <Checkbox
                            checked={!!obj_anexo_cabecalho_to_edit?.manutencao}
                            onChange={onInputEditTableChange_cabecalho}
                            name="manutencao"
                            disabled={!flag_editar_cabecalho}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": {
                                color: "#C94F1E",
                              },
                            }}
                          />
                        }
                      />
                    </FormGroup>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    <FormGroup onChange={onInputEditTableChange_cabecalho}>
                      <FormControlLabel
                        name="producao"
                        /* disabled={false} */
                        label={
                          <Typography
                            fontFamily="candara"
                            fontSize={16}
                          >
                            Em produção
                          </Typography>
                        }
                        aria-readonly
                        value={obj_anexo_cabecalho_to_edit?.producao}
                        control={
                          <Checkbox
                            checked={!!obj_anexo_cabecalho_to_edit?.producao}
                            onChange={onInputEditTableChange_cabecalho}
                            name="producao"
                            disabled={!flag_editar_cabecalho}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": {
                                color: "#C94F1E",
                              },
                            }}
                          />
                        }
                      />
                    </FormGroup>
                  </div>
                </div>

              </div>
            </Toolbar>

          }
        </TableContainer>
      </CustomThemeProvider>
      <ConfirmDialog
        open={open_dialog_tem_a_certeza_que_quer_eliminar}
        onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
        onConfirm={handle_delete_cabecalho}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </form>
  );
};
